// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type SharedWithMeQueryVariables = PrivateSchemaTypes.Exact<{
  topicEnrolmentLimit?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['NonNegativeInt']>;
}>;


export type SharedWithMeQuery = (
  { __typename?: 'Query' }
  & Pick<PrivateSchemaTypes.Query, 'assignedEnrolmentsCount'>
  & { me: (
    { __typename?: 'UserModelSelf' }
    & Pick<PrivateSchemaTypes.UserModelSelf, 'id'>
    & { assignedPathways: Array<(
      { __typename?: 'PathwayModelAsStudent' }
      & Pick<PrivateSchemaTypes.PathwayModelAsStudent, 'id' | 'title' | 'currentTopicVersionsCount'>
      & { coverImage?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'DocumentModel' }
        & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
      )>, tags: Array<(
        { __typename?: 'TagModel' }
        & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
      )>, currentEnrolment?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PathwayEnrolmentModelAsStudent' }
        & Pick<PrivateSchemaTypes.PathwayEnrolmentModelAsStudent, 'id' | 'target_date' | 'progress' | 'status'>
      )>, nextUnfinishedTopic?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicModelAsMember' }
        & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
        & { author: (
          { __typename?: 'UserModelPublicBase' }
          & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name'>
        ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicVersionModel' }
          & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'title' | 'summary' | 'background_img_id' | 'readDurationMins'>
        )>, coverImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
        )>, coverImageVariants: Array<(
          { __typename?: 'ImageVariantModel' }
          & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl' | 'size_key'>
        )> }
      )> }
    )> }
  ), assignedEnrolments: Array<(
    { __typename?: 'TopicEnrolmentModelAsStudent' }
    & Pick<PrivateSchemaTypes.TopicEnrolmentModelAsStudent, 'id' | 'pass_mark' | 'progress' | 'share_batch_ts' | 'target_completion_date' | 'status' | 'topic_id' | 'created_at'>
    & { sharedBy?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModelBase' }
      & Pick<PrivateSchemaTypes.UserModelBase, 'id' | 'display_name' | 'image_url'>
    )>, topic: (
      { __typename?: 'TopicModelAsMember' }
      & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id' | 'workspace_id'>
      & { author: (
        { __typename?: 'UserModelPublicBase' }
        & Pick<PrivateSchemaTypes.UserModelPublicBase, 'id' | 'display_name' | 'image_url'>
      ), currentTopicVersion?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicVersionModel' }
        & Pick<PrivateSchemaTypes.TopicVersionModel, 'id' | 'readDurationMins' | 'title' | 'summary'>
        & { backgroundImage?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl' | 'size_key'>
          )> }
        )> }
      )> }
    ) }
  )> }
);


export const SharedWithMeDocument = gql`
    query SharedWithMe($topicEnrolmentLimit: NonNegativeInt) {
  me {
    id
    assignedPathways {
      id
      title
      currentTopicVersionsCount
      coverImage {
        id
        cdnUrl
      }
      tags {
        id
        name
      }
      currentEnrolment {
        id
        target_date
        progress
        status
      }
      nextUnfinishedTopic {
        id
        author {
          id
          display_name
        }
        currentTopicVersion {
          id
          title
          summary
          background_img_id
          readDurationMins
        }
        coverImage {
          id
          cdnUrl
        }
        coverImageVariants {
          cdnUrl
          size_key
        }
      }
    }
  }
  assignedEnrolments(limit: $topicEnrolmentLimit) {
    id
    pass_mark
    progress
    share_batch_ts
    target_completion_date
    status
    topic_id
    created_at
    sharedBy {
      id
      display_name
      image_url
    }
    topic {
      id
      workspace_id
      author {
        id
        display_name
        image_url
      }
      currentTopicVersion {
        id
        readDurationMins
        title
        summary
        backgroundImage {
          id
          cdnUrl
          imageVariants {
            cdnUrl
            size_key
          }
        }
      }
    }
  }
  assignedEnrolmentsCount
}
    `;

/**
 * __useSharedWithMeQuery__
 *
 * To run a query within a React component, call `useSharedWithMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedWithMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedWithMeQuery({
 *   variables: {
 *      topicEnrolmentLimit: // value for 'topicEnrolmentLimit'
 *   },
 * });
 */
export function useSharedWithMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SharedWithMeQuery, SharedWithMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SharedWithMeQuery, SharedWithMeQueryVariables>(SharedWithMeDocument, options);
      }
export function useSharedWithMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SharedWithMeQuery, SharedWithMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SharedWithMeQuery, SharedWithMeQueryVariables>(SharedWithMeDocument, options);
        }
export type SharedWithMeQueryHookResult = ReturnType<typeof useSharedWithMeQuery>;
export type SharedWithMeLazyQueryHookResult = ReturnType<typeof useSharedWithMeLazyQuery>;
export type SharedWithMeQueryResult = Apollo.QueryResult<SharedWithMeQuery, SharedWithMeQueryVariables>;